export default "__VITE_ASSET__CBrHGO_x__"